import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../../components/common/general/CustomText/CustomText";
import { colors, spacing } from "../../../../styles/design-system";

type InsightsCalloutTone = "neutral" | "success" | "warning" | "brand";
type InsightsCalloutVariant = "boxed" | "rail";

type InsightsCalloutProps = {
  title: string;
  lines: string[];
  tone?: InsightsCalloutTone;
  variant?: InsightsCalloutVariant;
};

const toneStyles = {
  neutral: {
    backgroundColor: colors.grey[50],
    borderColor: colors.grey[200],
    titleColor: colors.grey[700],
  },
  success: {
    backgroundColor: colors.success[50],
    borderColor: colors.success[200],
    titleColor: colors.success[700],
  },
  warning: {
    backgroundColor: colors.error[50],
    borderColor: colors.error[200],
    titleColor: colors.error[700],
  },
  brand: {
    backgroundColor: colors.brand[50],
    borderColor: colors.brand[200],
    titleColor: colors.brand[700],
  },
} as const;

const InsightsCallout: React.FC<InsightsCalloutProps> = ({ title, lines, tone = "neutral", variant = "boxed" }) => {
  if (lines.length === 0) return null;

  const currentTone = toneStyles[tone];

  return (
    <View
      style={[
        variant === "rail" ? styles.railContainer : styles.container,
        variant === "rail"
          ? { borderLeftColor: currentTone.borderColor }
          : { backgroundColor: currentTone.backgroundColor, borderColor: currentTone.borderColor },
      ]}>
      <CustomText
        text={title}
        size="xs"
        weight="bold"
        useTranslationText={false}
        style={{ color: currentTone.titleColor }}
      />
      {lines.map((line, index) => (
        <CustomText
          key={`${title}-${index}`}
          text={`• ${line}`}
          size="xs"
          useTranslationText={false}
          style={styles.line}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderRadius: 10,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    gap: 4,
  },
  railContainer: {
    borderLeftWidth: 2,
    paddingVertical: spacing.xs,
    paddingLeft: spacing.sm,
    paddingRight: spacing.xs,
    gap: 4,
  },
  line: {
    color: colors.grey[700],
  },
});

export default InsightsCallout;
